import React, { useEffect } from 'react'
import ResponsiveScrollableWrapper from '../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import s from './MainDetail.less'
import classNames from 'classnames'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import useUIDisplay from '../ui/useUIDisplay'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import Anchor from '../genericComponents/Anchor'

export function MainDetail({ children, className }) {
  const { showUI, hideUI } = useUIDisplay(UI_ELEMENTS.POPIN)

  useEffect(() => {
    showUI()
    return () => hideUI()
  }, [])

  return (
    <div className={classNames(s.MainDetail, className, PAGE_CLASSES.mainDetail)}>
      <Anchor />
      <ResponsiveScrollableWrapper>{children}</ResponsiveScrollableWrapper>
    </div>
  )
}

export default MainDetail
